import React, { createContext, useReducer, ReactNode, useContext } from 'react';
import { reducer } from 'src/state-management/reducer'; // Import your reducer
import { State, initialState } from 'src/state-management/state'; // Import your state interface
import { Action } from 'src/state-management/action';

// Create the context
const StateContext = createContext<
  | {
      state: State;
      dispatch: React.Dispatch<Action>;
    }
  | undefined
>(undefined);

// Create the provider component
export const StateProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <StateContext.Provider value={{ state, dispatch }}>{children}</StateContext.Provider>;
};

// Custom hook to use the state context
export const useAppState = () => {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useAppState must be used within a StateProvider');
  }
  return context;
};
